import { put, select } from "redux-saga/effects";
import { changeStatus3 } from "../../actions";

/**
 * request a section change
 *
 * this function is called before a section change takes place. it is called from redux-saga and will issue
 * the correct redux-action if a change is allowed.
 *
 * NOTE: This function will mutate the action parameter and modify the index
 * NOTE: _validateSection has to be run in order for showHide to function properly. This is very important!
 *
 *
 * Special case: Previous (i.e. clicking previous / dir <= 0 ) should always granted passage through.
 *
 * @param {*} action - The redux action
 */
export function* requestChangeStatus3(action) {
  yield put(changeStatus3(action));
}

export default requestChangeStatus3;
